import { render, staticRenderFns } from "./TransactionTableCard.vue?vue&type=template&id=0b35f0f8&scoped=true"
import script from "./TransactionTableCard.vue?vue&type=script&lang=js"
export * from "./TransactionTableCard.vue?vue&type=script&lang=js"
import style0 from "./TransactionTableCard.vue?vue&type=style&index=0&id=0b35f0f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b35f0f8",
  null
  
)

export default component.exports